import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";

/* Pages */
import Sports from "./pages/Sports/Sports";
import Auto from "./pages/Auto/Auto";
import Technology from "./pages/Technology/Technology";
import Home from "./pages/Home/Home";
import Entertainment from "./pages/Entertainment/Entertainment";
import Immigration from "./pages/Immigration/Immigration";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AdvertisingPolicy from "./pages/AdvertisingPolicy";
import Heritage from "./pages/Heritage/Food";
import Food from "./pages/Heritage/Food";
import FoodDetail from "./pages/Heritage/DetailsPage";
import Beauty from "./pages/Heritage/Beauty";
import BeautyDetails from "./pages/Heritage/BeautyDetails";
import Fitness from "./pages/Heritage/Fitness";
import FitnessDetails from "./pages/Heritage/FitnessDetails";
import AncientFashion from "./pages/Heritage/Fashion";
import Travel from "./pages/Travel/Travel";
import Goa from "./pages/Travel/Goa";
import GoaD from "./pages/Travel/GoaD";
import CityDetail from "./pages/Travel/CityDetail";
import Traveler from "./pages/Travel/Traveler";
import Health from "./pages/Health/Health";
import HealthDetail from "./pages/Health/HealthDetail";
import Feeder from "./pages/Feeder/Feeder";
import HomeMasterDetail from "./pages/Home/HomeMasterDetail";
import AdminDashboard from "./components/Portal/AdminDashboard";
import NewYearWish from "./pages/NewYearWish";

/* Immigration Pages */
import SouthAfricaImmigrationGuidelines from "./pages/Immigration/immsa";
import ThailandVisaGuide from "./pages/Immigration/immtl";
import SouthKoreaVisaGuide from "./pages/Immigration/immsk";
import ImmigrationVisa from "./pages/Immigration/ImmigirationVisa";
import AustralianImmigrationGuidelines from "./pages/Immigration/immaus";
import UKVisaGuidelines from "./pages/Immigration/immuk";
import NewZealandImmigrationGuidelines from "./pages/Immigration/immnw";
import NetherlandsImmigrationGuidelines from "./pages/Immigration/immnl";
import CanadaImmigrationGuidelines from "./pages/Immigration/immca";
import JapanImmigrationGuidelines from "./pages/Immigration/immjp";
import SwitzerlandImmigrationGuidelines from "./pages/Immigration/immsl";
import GermanyImmigrationGuidelines from "./pages/Immigration/immgy";
import USImmigrationGuidelines from "./pages/Immigration/Immusa";

/* Common */
import Footer from "./components/common/Footer";
import "./App.css";

/* Services & Context */
import ipInfoService from "./services/ipInfoService";
import { LocationProvider } from "./context/LocationContext";
import MichiganSahanaEvent from "./pages/Sahana";
import AustraliaVisaReforms2026 from "./pages/Immigration/ImmNews/Australia";
import CanadaImmigrationReset2026 from "./pages/Immigration/ImmNews/Canada";
import GermanyImmigrationPush2026 from "./pages/Immigration/ImmNews/Germany";
import MiddleEastImmigration2026 from "./pages/Immigration/ImmNews/MiddleEast";
import NewZealandImmigrationReset2026 from "./pages/Immigration/ImmNews/NewZealand";
import SingaporeImmigration2026 from "./pages/Immigration/ImmNews/Singapore";
import UKImmigration2026 from "./pages/Immigration/ImmNews/UKImmigration";
import USImmigration2026 from "./pages/Immigration/ImmNews/USA";
import ScrollToTop from "./components/common/ScrollToTop";
import HoliWishesPage from "./pages/Holi";
import USCitizenTravelRegistration from "./components/StepUSReg";
import EventsPage from "./pages/Eventt/Event";
import RamNavamiWishesPage from "./pages/Holi";
import SriRamaKalyanamEvent from "./components/common/RamNavami";
import CybercrimeAlert from "./components/common/Cyber";
import Test from "./pages/Test";
import TrendingTechArticle2026 from "./components/common/NewArticle/TrendingTechArticle2026";
import AIInfrastructureBoom from "./components/common/NewArticle/AIInfrastructureBoom";
import Sitemap from "./sitemap";
import AboutUs from "./pages/about";
import BharatAbroadWeeklyNewsletter from "./components/common/NewArticle/BharatAbroadWeeklyNewsletter";
import H1BWageHike from "./components/common/NewArticle/H1BWageHike";
import ContactPage from "./pages/bharatabroad-contact";
import FdNcdArticle from "./components/common/NewArticle/Fin";
import IndiaForeignerRegistration from "./components/common/NewArticle/Indiaforeignerregistration";

/* ================= POPUP STYLES ================= */

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0,0,0,0.65)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 99999,
};

const popupStyle = {
  background: "#ffffff",
  padding: "12px",
  borderRadius: "16px",
  maxWidth: "90%",
  maxHeight: "90%",
  boxShadow: "0 15px 40px rgba(0,0,0,0.35)",
};

const imageStyle = {
  width: "auto",
  height: "500px",
  borderRadius: "12px",
};

/* ================= APP ================= */

function App() {
  const [showPopup, setShowPopup] = useState(true);

  /* Auto-close popup after 5 seconds */
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  /* Init IP service */
  useEffect(() => {
    ipInfoService.init();
  }, []);

  return (
    <LocationProvider>
      {/* 🔥 AUTO POPUP */}
      {/* {showPopup && (
        <div style={overlayStyle}>
          <div style={popupStyle}>
            <img
              src="https://ayg.s3.us-east-2.amazonaws.com/WhatsApp+Image+2026-03-20+at+2.07.30+PM.jpeg"
              alt="Festival Popup"
              style={imageStyle}
            />
          </div>
        </div>
      )} */}

      <Router>
        <div className="App">
          <ScrollToTop />
          <Routes>
            {/* Home */}
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/homemaster/:id" element={<HomeMasterDetail />} />

            {/* Sections */}
            <Route path="/sports/*" element={<Sports />} />
            <Route path="/auto" element={<Auto />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/entertainment" element={<Entertainment />} />

            {/* Heritage */}
            <Route path="/heritage" element={<Heritage />} />
            <Route path="/heritage/food" element={<Food />} />
            <Route path="/heritage/food/:name" element={<FoodDetail />} />
            <Route path="/heritage/fitness" element={<Fitness />} />
            <Route
              path="/heritage/fitness/:name"
              element={<FitnessDetails />}
            />
            <Route path="/heritage/beauty" element={<Beauty />} />
            <Route path="/heritage/beauty/:name" element={<BeautyDetails />} />
            <Route path="/heritage/fashion" element={<AncientFashion />} />

            {/* Health */}
            <Route path="/health" element={<Health />} />
            <Route path="/health/:topicId" element={<HealthDetail />} />

            {/* Travel */}
            <Route path="/travel" element={<Travel />} />
            <Route path="/traveler" element={<Traveler />} />
            <Route path="/goa-tourism" element={<Goa />} />
            <Route path="/goa" element={<GoaD />} />
            <Route path="/city/:cityName" element={<CityDetail />} />

            {/* Immigration */}
            <Route path="/immigration" element={<Immigration />} />
            <Route path="/immigration/india" element={<ImmigrationVisa />} />
            <Route
              path="/immigration/usa"
              element={<USImmigrationGuidelines />}
            />
            <Route path="/immigration/uk" element={<UKVisaGuidelines />} />
            <Route
              path="/immigration/australia"
              element={<AustralianImmigrationGuidelines />}
            />
            <Route
              path="/immigration/newzealand"
              element={<NewZealandImmigrationGuidelines />}
            />
            <Route
              path="/immigration/netherlands"
              element={<NetherlandsImmigrationGuidelines />}
            />
            <Route
              path="/immigration/canada"
              element={<CanadaImmigrationGuidelines />}
            />
            <Route
              path="/immigration/japan"
              element={<JapanImmigrationGuidelines />}
            />
            <Route
              path="/immigration/switzerland"
              element={<SwitzerlandImmigrationGuidelines />}
            />
            <Route
              path="/immigration/germany"
              element={<GermanyImmigrationGuidelines />}
            />
            <Route
              path="/immigration/south-africa"
              element={<SouthAfricaImmigrationGuidelines />}
            />
            <Route
              path="/immigration/thailand"
              element={<ThailandVisaGuide />}
            />
            <Route
              path="/immigration/south-korea"
              element={<SouthKoreaVisaGuide />}
            />

            {/* Imm News  */}
            <Route
              path="/news/australia-visa-reforms-2026"
              element={<AustraliaVisaReforms2026 />}
            />
            <Route
              path="/news/canada-immigration-reset-2026"
              element={<CanadaImmigrationReset2026 />}
            />
            <Route
              path="/news/germany-immigration-push-2026"
              element={<GermanyImmigrationPush2026 />}
            />
            <Route
              path="/news/middle-east-immigration-2026"
              element={<MiddleEastImmigration2026 />}
            />
            <Route
              path="/news/new-zealand-immigration-reset-2026"
              element={<NewZealandImmigrationReset2026 />}
            />
            <Route
              path="/news/singapore-immigration-2026"
              element={<SingaporeImmigration2026 />}
            />
            <Route
              path="/news/uk-immigration-2026"
              element={<UKImmigration2026 />}
            />
            <Route
              path="/news/immigration-2026/us"
              element={<USImmigration2026 />}
            />

            {/* Others */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/Advertising-policy" element={<AdvertisingPolicy />} />
            <Route path="/feeder/*" element={<Feeder />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/michigan-sahana" element={<MichiganSahanaEvent />} />
            <Route path="/ram-navami" element={<SriRamaKalyanamEvent />} />
            <Route path="/cyber-crime-alert" element={<CybercrimeAlert />} />
            <Route path="/event" element={<EventsPage />} />
            <Route path="/test" element={<Test />} />
            <Route
              path="/articles/ai-agents-mainstream-2026"
              element={<TrendingTechArticle2026 />}
            />
            <Route
              path="/articles/ai-power-hunger-strains-national-grids-2026"
              element={<AIInfrastructureBoom />}
            />
            <Route
              path="/newsletter/weekly-may-2026"
              element={<BharatAbroadWeeklyNewsletter />}
            />
            <Route
              path="/articles/us-h1b-wage-hike-indian-professionals-2026"
              element={<H1BWageHike />}
            />
            <Route
              path="/articles/immigration-and-foreigners-rules"
              element={<IndiaForeignerRegistration />}
            />
            <Route path="/articles/fd-ncd" element={<FdNcdArticle />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactPage />} />
          </Routes>
        </div>

        <Footer />
      </Router>
    </LocationProvider>
  );
}

export default App;
